<cc-side-bar class="archive-sidebar" [(sidebarToggled)]="sidebarToggledChange"
             (sidebarToggledChange)="SizeChanged($event)"
             [menuItemsTop]="menuItemsTop" [menuItemsBottom]="menuItemsBottom">
  <ng-content body select="[body]"></ng-content>
  <ng-content bottom select="[bottom]"></ng-content>
</cc-side-bar>

